/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/styles";
import { Button, CardHeader, Divider, TextField } from "@material-ui/core";
import ViewListIcon from "@material-ui/icons/ViewList";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    height: "100%",
    marginBottom: "1%",
  },

  itemCard: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    width: "98%",
    marginTop: 10,
    overflow: "visible",
    backgroundColor: "#f2f2f2",
    marginBottom: 10,
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 20,
  },
  itemTitle: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 15,
  },
  itemTitleQAFailed: {
    color: "white",
    display: "flex",
    fontSize: 15,
  },

  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "90%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 20,
  },
  itemCardTitleDivider: {
    width: "100%",
    backgroundColor: "grey",
    opacity: "0.5",
  },
  cardContent: {
    padding: 0,
    width: "90%",
    marginLeft: 20,
    overflow: "auto",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  itemCardContent: {
    padding: 0,
    width: "90%",
    marginLeft: 20,
    marginTop: 10,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  },

  listItem: {
    outline: "none",
    cursor: "pointer",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
  },
  listItemContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  listItemKey: {
    fontSize: 14,
    textAlign: "left",
    fontWeight: 600,
    width: "25%",
  },
  listItemValue: {
    fontSize: 13,
    textAlign: "left",
    width: "25%",
  },
  halfWidthRight: {
    width: "50%",
    textAlign: "right",
  },
  subListItemContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  totalAmount: {
    fontSize: 14,
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginRight: 10,
  },
  barcodeImage: {
    display: "flex",
    width: "100%",
    justifyContent: "end",
  },
  circularProgressStyle: {
    marginTop: 10,
  },
  itemCardContentTitle: {
    fontSize: 14,
    fontWeight: 700,
    textDecoration: "underline",
  },
  listItemActive: {
    backgroundColor: "#ffdddd !important",
  },
  itemSubTitle: {
    fontSize: 15,
    marginLeft: 5,
  },
  qaCheckedData: {
    width: "100%",
    fontSize: "11px",
    display: "flex",
    justifyContent: "left",
    textAlign: "left",
  },
  qaItem: {
    display: "flex",
    justifyContent: "space-between",
    textAlign: "left",
    paddingRight: 10,
  },
});

class SalesTab extends React.Component {
  componentDidUpdate() {
    var isBlurred = false;
    this.checkFocusInterval = setInterval(() => {
      const { traybarCode } = this.props.values;

      if (this.textFieldRef && !traybarCode) {
        this.textFieldRef.focus();
        isBlurred = false;
      } else if (this.textFieldRef && traybarCode && !isBlurred) {
        this.textFieldRef.blur(); // Unfocus when itemBarCode is populated
        isBlurred = true;
      }
    }, 5000); // Checks every 500ms, adjust as needed
  }

  componentWillUnmount() {
    clearInterval(this.checkFocusInterval); // Clean up the interval on unmount
  }

  render() {
    const { classes, handleQACheckList, toggleChangeQAStatusDialog } =
      this.props;
    return (
      <React.Fragment>
        <Card className={classes.card}>
          <CardHeader
            style={{ paddingBottom: 10 }}
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: 15,
                }}
              >
                <span className={classes.title}>
                  <ViewListIcon className={classes.titleIcon} />
                  <b>Details</b>
                </span>
                <span>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    placeholder={
                      this.props.values.lastTrayBarCode
                        ? `Scanned: ${this.props.values.lastTrayBarCode}`
                        : "Tray Barcode"
                    }
                    variant="outlined"
                    name="traybarCode"
                    onBlur={this.props.onFocusOutTrayBarCodeField}
                    // disabled={this.props.values.salesData.length>0}
                    inputRef={(ref) => (this.textFieldRef = ref)}
                    value={this.props.values.traybarCode}
                    onChange={this.props.onHandleChange}
                    disabled={this.props.values.onScanTrayBarCodeLoading}
                  />
                </span>
              </div>
            }
          />
          <Divider className={classes.titleDivider} />
          <CardContent className={classes.cardContent}>
            {this.props.values.onScanTrayBarCodeLoading ? (
              <div className={classes.circularProgressStyle}>
                <CircularProgress />
              </div>
            ) : (
              <Fragment>
                {this.props.values.salesData.map((sale) => {
                  const { qaActivitiesList = [] } = sale;

                  return (
                    <Card key={sale} className={classes.itemCard}>
                      <CardHeader
                        onClick={() =>
                          this.props.getImagesOrderIdAndProductId(
                            sale,
                            sale.orderId,
                            sale.productId,
                            sale.id
                          )
                        }
                        style={{
                          cursor: "pointer",
                          backgroundColor: `${
                            // isSelected ? "rgb(211 218 255)" : "#d9d8d8"

                            sale.isQAFailed == 1
                              ? "#fcae1e"
                              : sale.isDisputed == 1
                              ? "#ffb4b0"
                              : "#d9d8d8"
                          }`,
                          borderTopRightRadius: 10,
                          borderTopLeftRadius: 10,
                          padding: "10px 16px",
                        }}
                        title={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span
                              className={
                                sale.isQAFailed == 1 || sale.isDisputed == 1
                                  ? classes.itemTitleQAFailed
                                  : classes.itemTitle
                              }
                            >
                              <b>{`${sale.productUserLabel} - Copies: ${sale.quantity}`}</b>
                            </span>
                            {/* {isSelected ? (
                              <div>
                                <CheckBoxTwoToneIcon
                                  style={{ color: "#3f51b5" }}
                                  //fontSize="large"
                                  color="secondary"
                                />
                              </div>
                            ) : (
                              <div>
                                <CheckBoxOutlineBlankTwoToneIcon
                                  style={{ color: "#3f51b5" }}
                                  //fontSize=""
                                  color="secondary"
                                />
                              </div>
                            )} */}
                          </div>
                        }
                      />
                      <Divider className={classes.itemCardTitleDivider} />
                      <CardContent className={classes.itemCardContent}>
                        <div className={classes.itemCardContentTitle}>
                          Size:
                        </div>
                        <div style={{ margin: 10 }}>
                          {sale.productSizeLabel}
                        </div>
                        <div className={classes.itemCardContentTitle}>
                          Paper Quality:
                        </div>
                        <div style={{ margin: 10 }}>
                          {sale.productTypeLabel}
                        </div>
                        <div className={classes.itemCardContentTitle}>
                          Lamination:
                        </div>
                        <div style={{ margin: 10 }}>
                          {" "}
                          {sale.productLaminationLabel}
                        </div>

                        <div className={classes.itemCardContentTitle}>
                          QA Check List:
                        </div>
                        <div
                          style={{
                            marginTop: -6,
                            paddingLeft: 5,

                            width: "100%",
                          }}
                        >
                          <ul style={{ padding: 0 }}>
                            {qaActivitiesList.map((qaItem) => {
                              return (
                                <div
                                  key={qaItem}
                                  style={{
                                    paddingBottom: 15,
                                  }}
                                >
                                  <div
                                    key={qaItem.id}
                                    className={classes.qaItem}
                                  >
                                    <div style={{ width: "50%" }}>
                                      {qaItem.label}
                                    </div>
                                    <div
                                      style={{
                                        width: "50%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Button
                                        name={sale.id}
                                        color="default"
                                        variant="contained"
                                        style={{ marginLeft: "-7px" }}
                                        onClick={() =>
                                          toggleChangeQAStatusDialog(
                                            0,
                                            sale,
                                            qaItem,
                                            qaItem.remarksNo
                                          )
                                        }
                                      >
                                        No
                                      </Button>
                                    </div>
                                  </div>
                                  {qaItem.lastCheckedOnLabel && (
                                    <div className={classes.qaCheckedData}>
                                      <p>
                                        last checked at{" "}
                                        <b>{qaItem.lastCheckedOnLabel}</b> by{" "}
                                        <b>{qaItem.lastCheckedByLabel}</b>
                                      </p>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </ul>
                          <div
                            style={{
                              width: "95%",
                              marginTop: "2.5%",
                            }}
                          >
                            <Button
                              name={sale.id}
                              variant="contained"
                              color="primary"
                              style={{ width: "95%", marginRight: "2.5%" }}
                              onClick={() => handleQACheckList(1, sale, 1, 0)}
                            >
                              Yes to All
                            </Button>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
              </Fragment>
            )}
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

SalesTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  getImagesOrderIdAndProductId: PropTypes.func,
  handleQACheckList: PropTypes.func,
  toggleChangeQAStatusDialog: PropTypes.func,
  onFocusOutTrayBarCodeField: PropTypes.func,
  onHandleChange: PropTypes.func,
};

SalesTab.defaultProps = {
  values: {},
  getImagesOrderIdAndProductId: (fn) => fn,
  handleQACheckList: (fn) => fn,
  toggleChangeQAStatusDialog: (fn) => fn,
  onFocusOutTrayBarCodeField: (fn) => fn,
  onHandleChange: (fn) => fn,
};

export default withStyles(useStyles)(SalesTab);
